module.exports = __webpack_public_path__ + "static/media/logo.40c58ff7.svg";